import {
	VEHICLE,
	LEASE_INFORMATION,
	VEHICLE_SUGGESTIONS,
	DRIVER_SUGGESTIONS
} from "./content";

import { DASHBOARD_PROFILE } from './routes/const';

import { HeaderTab } from "./components";
import { NitroText, NitroBadge } from "nitro-components";
import styled from "styled-components";
import moment from "moment";
import React from "react";

export const sum = (a, b) => {
	return a + b;
};

const TabContainer = styled.div`
padding-right:12px;
padding-left:12px;
display:flex;
`;

//TODO break down this method for intial render and active highlight -sri
export const transformTabs = (leases, activeTab) => {
	let tranformedTabs = [];
	for (const [index, lease] of leases.entries()) {
		let tab = {};
		tab.type = lease.type || VEHICLE;
		if (tab.type === VEHICLE) {
			tab.key = lease.LeaseId + '';
			tab.value = lease.RegistrationNumber;
			tab.leaseId = lease.LeaseId;
			tab.CompanyCode = lease.CompanyCode;
			tab.CompanyName = lease.CompanyName;
			tab.leaseData = {
				ImageKey: lease.ImageKey,
				MakeModel: lease.MakeModel
			};
			tab.alert = lease.Indicator;
			tab.variant = lease.Variant;
		} else {
			tab = lease;
		}

		switch (tab.type) {
			case VEHICLE: {
				const transformedTabObj = {
					content: (
						<TabContainer>
							<HeaderTab
								value={tab.value}
								iconName={tab.alert ? "filled-warning" : ""}
								iconVariant={tab.variant}
								iconSize={18}
								active={activeTab.key === tab.key}
							/>
						</TabContainer>
					),
					...tab
				};
				tranformedTabs.push(transformedTabObj);
				break;
			}
			case LEASE_INFORMATION: {
				const transformedTabObj = {
					content: (
						<TabContainer>
							<NitroText size={14} bold nowrap>
								{tab.value}
							</NitroText>
							{" "}

						</TabContainer>
					),
					...tab
				};
				tranformedTabs.push(transformedTabObj);
				break;
			}

			case VEHICLE_SUGGESTIONS: {
				const transformedTabObj = {
					content: (
						<TabContainer>
							<NitroText size={14} bold nowrap>
								{tab.value}
							</NitroText>
							{" "}
							<NitroBadge
								label={2}
								size={10}
								variant={
									activeTab.key === tab.key
										? "secondary"
										: "base3"
								}
								top={5}
							/>
						</TabContainer>
					),
					...tab
				};
				tranformedTabs.push(transformedTabObj);
				break;
			}
			case DRIVER_SUGGESTIONS: {
				const transformedTabObj = {
					content: (
						<TabContainer>
							<NitroText size={14} bold nowrap>
								{tab.value}
							</NitroText>
							{" "}
							<NitroBadge
								label={4}
								size={10}
								variant={
									activeTab.key === tab.key
										? "secondary"
										: "base3"
								}
								top={5}
							/>
						</TabContainer>
					),
					...tab
				};
				tranformedTabs.push(transformedTabObj);
				break;
			}
			default: {
				console.error("Invalid tab type option");
				throw "Invalid tab type option";
			}
		}
	}
	return tranformedTabs;
};

export const transformContactsToSidePanel = (driverName, contactInfo) => {
	/*let contactData = [
		{ "@DisplayType": "navigation-header", Title: "Contact Driver" },
		{
			"@DisplayType": "action-button",
			label: `Edit ${driverName} contact info`,
			icon: "edit"
		}
	];*/

	let contactData = [];

	if (contactInfo) {
		contactData.push({
			"@DisplayType": "summary-table",
			ExtraSpacingRows: "true",
			formatting: false,
			footerDivider: true,
			Header: "",
			Columns: [{ "@Name": "Label" }, { "@Name": "Value" }],
			Rows: [
				{
					Label: "Mobile",
					Value: contactInfo.DriverMobile,
					type: "tel"
				},
				{
					Label: "Email",
					Value: contactInfo.DriverEmail,
					type: "email"
				},
				{ Label: "Address", Value: contactInfo.DriverAddress }
			]
		});

		/*contactData.push({
			"@DisplayType": "summary-table",
			ExtraSpacingRows: "true",
			formatting: false,
			Header: "",
			Columns: [{ "@Name": "Label" }, { "@Name": "Value" }],
			Rows: [{ Label: "Skype ID", Value: "jummyjonsey", type: "skype" }]
		});*/
	}

	return contactData;
};

export const transformLeaseDetailsForSidePanel = (
	currentLease,
	previousLease,
  onPanelClick,
) => {
	const leaseData = [
		{ "@DisplayType": "navigation-header", Title: "Vehicle history" }
	];
	if (currentLease && currentLease.length) {
		leaseData.push({
			"@DisplayType": "text-block",
			IsRootHeader: "true",
			Header: `Current vehicle${currentLease.length !== 1 ? 's' : ''}`
		});

		for (let i = 0; i < currentLease.length; i++) {
			leaseData.push({
				"@DisplayType": "card",
				Children: [
					{
						"@DisplayType": "vehicle-card",
						MakeModel: currentLease[i].MakeModel,
						ImageKey: currentLease[i].ImageKey,
						LeaseId: currentLease[i].LeaseId,
						RegistrationNumber: currentLease[i].RegistrationNumber,
            onPanelClick: onPanelClick,
						route: DASHBOARD_PROFILE,
					}
				]
			});
		}
	}

	if (previousLease && previousLease.length) {
		leaseData.push({
			"@DisplayType": "text-block",
			IsRootHeader: "true",
			Header: "Past vehicles"
		});

		for (let i = 0; i < previousLease.length; i++) {
			leaseData.push({
				"@DisplayType": "card",
				Children: [
					{
						"@DisplayType": "vehicle-card",
						MakeModel: previousLease[i].MakeModel,
						ImageKey: previousLease[i].ImageKey,
						LeaseId: previousLease[i].LeaseId,
						RegistrationNumber: previousLease[i].RegistrationNumber,
            onPanelClick: onPanelClick,
						route: DASHBOARD_PROFILE,
					}
				]
			});
		}
	}

	return leaseData;
};

export const transformDriverDetailsForSidePanel = (
	driverList,
  onPanelClick,
  onButtonClick,
) => {
	const leaseData = [
		{ "@DisplayType": "navigation-header", Title: "Driver history" }
	];

  const currentDriver = driverList[0];
	const pastDrivers = driverList.slice(1, driverList.length);

	if (currentDriver) {
		leaseData.push({
			"@DisplayType": "text-block",
			IsRootHeader: "true",
			Header: "Current driver"
		});

		leaseData.push({
			"@DisplayType": "driver-card",
      DriverID: currentDriver.DriverId,
      DriverFirstName: currentDriver.DriverFirstName,
      DriverLastName: currentDriver.DriverSurname,
      DriverTitleMessage: `Allocated on ${moment(currentDriver.StartDate, 'DD/MM/YYYY').format('D MMM YYYY')}`,
      onPanelClick: onPanelClick,
      buttonText: 'Allocate a different driver',
      onButtonClick: onButtonClick,
			route: DASHBOARD_PROFILE,
		});
	}

	if (pastDrivers && pastDrivers.length) {
		leaseData.push({
			"@DisplayType": "text-block",
			IsRootHeader: "true",
			Header: "Past drivers"
		});

		for (let i = 0; i < pastDrivers.length; i++) {
			leaseData.push({
					"@DisplayType": "driver-card",
					DriverID: pastDrivers[i].DriverId,
					DriverFirstName: pastDrivers[i].DriverFirstName,
					DriverLastName: pastDrivers[i].DriverSurname,
					DriverTitleMessage: `${moment(pastDrivers[i].StartDate, 'DD/MM/YYYY').format('D MMM YYYY')} - ${moment(pastDrivers[i].EndDate, 'DD/MM/YYYY').format('D MMM YYYY')}`,
          onPanelClick: onPanelClick,
					route: DASHBOARD_PROFILE,
			});
		}
	}

	return leaseData;
};



// WEBPACK FOOTER //
// ./src/features/dashboard/helpers.js